import { render, staticRenderFns } from "./UserPlan.vue?vue&type=template&id=463406d5&scoped=true"
import script from "./UserPlan.vue?vue&type=script&lang=js"
export * from "./UserPlan.vue?vue&type=script&lang=js"
import style0 from "./UserPlan.vue?vue&type=style&index=0&id=463406d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463406d5",
  null
  
)

export default component.exports